module.exports = __webpack_public_path__ + "img/ico_status_danger.7f0a76d3.svg";